<template>
  <div>
    <v-btn
      v-if='haveSyncs'
      color='#7972c0'
      depressed
      outlined
      @click='$router.push({ name: "IntegrationAllSyncs" })'
      class='mb-6'
    >
      <v-icon>
        mdi-arrow-left
      </v-icon>
      <span class='ml-2'>
        current syncs
      </span>
    </v-btn>
    <p class='subtitle-1 text-grey-8'>
      Select and link your third-party sales channels, payment platforms,
      shipping services and more with Britecheck, so thery can seamlessy
      share data:
    </p>
    <v-row class='mt-6'>
      <v-col xs='12' sm='6' md='4' lg='3' xl='3' cols='12' v-for='(item, i) in awailableSystems' :key='i'>
        <v-card
          class='px-4 integration__card'
          link
          :to='{
            name: "IntegrationSync",
            params: {
              id: item.alias
            }
          }'
        >
          <v-card-title class='flex-center'>
            <span class='text-center font-weight-medium'>{{item.name}}</span>
          </v-card-title>
          <v-divider />
          <div class='flex align-center justify-center' style='height: 150px'>
            <v-img
              :lazy-src='$publicPath + item.image.split("/public")[1]'
              :src='$publicPath + item.image'
              max-width='80%'
              max-height='130'
              width='100%'
              class='block'
              style='object-fit: contain'
            />
          </div>
          <v-divider />
          <p
            class='text-grey-8 subtitle-2 pt-2 pb-4'
          >
            {{ item.description }}
          </p>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import service from '@/services/integrations'
import { mapGetters } from 'vuex'
export default {
  name: 'IntegrationsSelect',
  computed: {
    ...mapGetters('integrations', {
      integrationsList: 'getIntegrationsList'
    }),
    ...mapGetters('warehouses', {
      warehousesList: 'getWarehousesList'
    }),
    haveSyncs() {
      return this.integrationsList && this.integrationsList.length
    }
  },
  data: () => ({
    awailableSystems: []
  }),
  async created() {
    this.hostAddress = location.origin
    const response = await service.getIntegrationServicesList()
    if (response?.data?.error?.type === 200) {
      this.awailableSystems = response.data.data
      this.$store.commit('warehouses/setWarehousesList', this.warehousesList.map(w => { return { ...w, selected: false } }))
    }
  }
}
</script>

<style scoped lang="scss">
  .integration {
    &__card {
      border: 1px solid transparent;
      transition: linear 0.2s;
      .v-card__title span {
        color: #000;
        font-weight: 600;
        transition: linear 0.2s;
      }
      &:hover {
        border-color: rgba(gray, 0.35);
        box-shadow: none !important;
        background-color: #f5f5f5;
        .v-card__title span {
          color: #7671bd
        }
      }
    }
  }
</style>
